import { render, staticRenderFns } from "./RatioHotelFlightTile.vue?vue&type=template&id=3555ad81"
import script from "./RatioHotelFlightTile.vue?vue&type=script&lang=js"
export * from "./RatioHotelFlightTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports